import { Component, EventEmitter, Input, OnInit, Output, forwardRef } from '@angular/core';
import { ControlContainer, FormGroupDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SmSelectComponent } from '../sm-select/sm-select.component';
import { SmUiComponent } from '../sm-ui/sm-ui.component';

@Component({
  selector: 'sm-ng-select',
  templateUrl: './sm-ng-select.component.html',
  styleUrls: ['./sm-ng-select.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SmNgSelectComponent),
            multi: true
        }
    ]
})
export class SmNgSelectComponent extends SmUiComponent implements OnInit {
  @Input() options;
  @Output() selected = new EventEmitter<any>();
  @Output() filteredState = new EventEmitter<any>();
  isDisable: boolean = true;


    override ngOnInit(): void {
      super.ngOnInit();
    //  

  }


  onMaterialGroupChange(event): any {
      this.selected.emit(event);
      return event;
  }

  onSelectAll(select): void {
      const selected = this.options.map(item => item.id);
      this.formcontrol.patchValue(selected);
      select.close();
  }

  filterEmitter(event): void {
      this.props.filterOptions.forEach((filter, index) => {
          if (filter.id === event.target.id) {
              filter.state = event.target.checked;
          }
      });
      this.filteredState.emit(this.props.filterOptions);
  }
}
// import {
//   Component,
//   EventEmitter,
//   Input,
//   OnChanges,
//   OnInit,
//   Output,
//   SimpleChanges,
//   forwardRef,
// } from "@angular/core";
// import {
//   ControlContainer,
//   FormGroupDirective,
//   NG_VALUE_ACCESSOR,
// } from "@angular/forms";
// import { SmSelectComponent } from "../sm-select/sm-select.component";
// import { SmUiComponent } from "../sm-ui/sm-ui.component";

// @Component({
//   selector: "sm-ng-select",
//   templateUrl: "./sm-ng-select.component.html",
//   styleUrls: ["./sm-ng-select.component.scss"],
//   viewProviders: [
//     { provide: ControlContainer, useExisting: FormGroupDirective },
//   ],
//   providers: [
//     {
//       provide: NG_VALUE_ACCESSOR,
//       useExisting: forwardRef(() => SmNgSelectComponent),
//       multi: true,
//     },
//   ],
// })
// export class SmNgSelectComponent
//   extends SmUiComponent
//   implements OnInit, OnChanges
// {
//   @Input() options;
//   @Output() selected = new EventEmitter<any>();
//   @Output() filteredState = new EventEmitter<any>();
//   isDisable: boolean = true;
//   override ngOnInit(): void {
//     super.ngOnInit();
//     console.log(this.props);
//   }

//   ngOnChanges(changes: SimpleChanges): void {
//     if (changes["options"]) {
//       this.options = [
//         { student_id: "selectAll", name: "Select All" },
//         ...this.props.options,
//       ];
//       console.log("Options changed:", this.props.options);
//     }
//   }

//   onMaterialGroupChange(event): any {
//     this.selected.emit(event);
//     return event;
//   }

//   // onSelectAllChange(event: any, ngSelect: any): void {
//   //   const isChecked = event.target.checked;
//   //   console.log(ngSelect)
//   //   if (isChecked) {
//   //     const allOptionValues = this.options
//   //       .filter((option) => option.student_id !== "selectAll")
//   //       .map((option) => option.student_id);
//   //     this.formcontrol.patchValue(allOptionValues);
//   //   } else {
//   //     this.formcontrol.patchValue([]);
//   //   }
//   //   ngSelect.close();
//   // }

//   onSelectAllChange(event: any, ngSelect: any): void {
//     const isChecked = event.target.checked;
//     if (isChecked) {
//       const allOptionValues = this.options
//         .filter((option) => option.student_id !== "selectAll")
//         .map((option) => option.id);
//       this.formcontrol.patchValue(allOptionValues);
//     } else {
//       this.formcontrol.patchValue([]);
//     }

//     ngSelect.close();
//   }

//   areAllSelected(): boolean {
//     const selectedValues = this.formcontrol.value || [];
//     const optionValues = this.options
//       .filter((option) => option.student_id !== "selectAll")
//       .map((option) => option.id);
//     return optionValues.every((value) => selectedValues.includes(value));
//   }

//   filterEmitter(event): void {
//     this.props.filterOptions.forEach((filter) => {
//       if (filter.id === event.target.id) {
//         filter.state = event.target.checked;
//       }
//     });
//     this.filteredState.emit(this.props.filterOptions);
//   }
// }
